export const STATUSES = {
  MISSION_BOOKED_IN_ACTIVE_SLOT: 'MISSION_BOOKED_IN_ACTIVE_SLOT',
  MISSION_BOOKED_IN_NOT_ACTIVE_SLOT: 'MISSION_BOOKED_IN_NOT_ACTIVE_SLOT',
  AVAILABLE_SLOT: 'AVAILABLE_SLOT',
  NOT_AVAILABLE_SLOT: 'NOT_AVAILABLE_SLOT',
  DONT_HAVE_AVAILABILITY: 'DONT_HAVE_AVAILABILITY',
  MISSION_BOOKED_WITHOUT_AVAILABILITY: 'MISSION_BOOKED_WITHOUT_AVAILABILITY',
  MISSION_BOOKED_ON_TIME_OFF: 'MISSION_BOOKED_ON_TIME_OFF',
  TIME_OFF: 'TIME_OFF',
  IS_EXPIRED_CONTRACT: 'IS_EXPIRED_CONTRACT',
  MISSION_BOOKED_WITH_EXPIRED_CONTRACT: 'MISSION_BOOKED_WITH_EXPIRED_CONTRACT',
  MISSION_NOT_SHOWN: 'MISSION_NOT_SHOWN',
}

export const DAYS_OF_WEEK = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
]

export const HEADERS = [
  { id: 'name', name: 'BA name', align: 'left', sort: true },
  { id: 'documentType', name: 'Contract Type', align: 'left', sort: true },
  {
    id: 'userMissionInThisWeek',
    name: 'Missions booked',
    align: 'center',
    sort: true,
  },
  {
    id: 'availableMissions',
    name: 'Missions remaining',
    align: 'center',
    sort: true,
  },
  {
    id: 'extraMissionUsed',
    name: 'Extra Missions booked',
    align: 'center',
    sort: true,
  },
  {
    id: 'availableExtraMissions',
    name: 'Extra Missions remaining',
    align: 'center',
    sort: true,
  },
  {
    id: 'maxMissionPerWeek',
    name: 'Max Missions In Week',
    align: 'center',
    sort: true,
  },
]

export const DAY_TIMES = ['MORNING', 'LUNCH', 'AFTERNOON']
